<app-split [id]="splitComponentId" (componentClose)="onAnnexPanelClose()">
<div class="annexes-registry container">
  <div class="content">
    <div class="content-card filters">
      <div class="top">
        <div class="top__left"></div>
        <div class="top__right">
          <div class="filter-button-container">
            <button (click)="resetFilters()" class="top__button top__button-clear">
              <mat-icon>close</mat-icon>
              {{ 'Reset' | translate }}
            </button>
            <button
              (click)="toggleFiltersPanel()"
              class="top__button top__button-filter"
              [matBadge]="filters.length"
              matBadgeSize="small"
              [matBadgeHidden]="!filters.length"
            >
              <mat-icon>filter_alt</mat-icon>
              {{ 'Filter' | translate }}
            </button>
          </div>
        </div>
      </div>
      @if (areFiltersExpanded) {
      <app-list-filter></app-list-filter>
      }
    </div>

    <div class="content-card" [ngClass]="{ 'filters-opened': areFiltersExpanded }">
      <div #tableContainer class="wrapper custom-table">
        <cdk-virtual-scroll-viewport gridTableVirtualScroll (scrolledIndexChange)="nextBatch($event)">
          <mat-table
            class="table"
            matSort
            matSortActive="StartDate"
            matSortDirection="desc"
            matSortDisableClear
            [dataSource]="dataSource"
            (matSortChange)="onSortChange()"
            [trackBy]="trackBy"
          >
            <!-- LastName Column -->
            <ng-container matColumnDef="LastName" [sticky]="screenService.isAboveMd$ | async">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'WL-Name' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                <a
                  class="user"
                  [routerLink]="['/profile', element.WorkerId]"
                  [matTooltip]="'WL-ShowWokerProfile' | translate"
                  matTooltipPosition="above"
                  matTooltipClass="annexes-registry-tooltip"
                >{{ element.LastName }} {{ element.FirstName }}</a>
                @if (element.IsConsistent === false && isAdmin) {
                <mat-icon
                  class="warn-icon"
                  [matTooltip]="'AnnexRegistry.InconsistentAnnex' | translate"
                  matTooltipClass="annexes-registry-tooltip"
                >warning</mat-icon>
                }
              </mat-cell>
            </ng-container>

            <!-- Company Column -->
            <ng-container matColumnDef="Company">
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header="CompanyName"
                class="hidden-sort"
                [style.minWidth.px]="getColumnWidth('Company')"
                [style.maxWidth.px]="getColumnWidth('Company')"
              >
                {{ 'Company' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" [style.minWidth.px]="getColumnWidth('Company')" [style.maxWidth.px]="getColumnWidth('Company')">
                <span [matTooltip]="element.CompanyName" matTooltipClass="annexes-registry-tooltip">{{ element.CompanyName }}</span>
              </mat-cell>
            </ng-container>

            <!-- EmployerName Column -->
            <ng-container matColumnDef="EmployerName">
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header="EmployerName"
                class="hidden-sort"
                [style.minWidth.px]="getColumnWidth('EmployerName')"
                [style.maxWidth.px]="getColumnWidth('EmployerName')"
              >
                {{ 'WL-EmployerName' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" [style.minWidth.px]="getColumnWidth('EmployerName')" [style.maxWidth.px]="getColumnWidth('EmployerName')">
                <span [matTooltip]="element.EmployerName" matTooltipClass="annexes-registry-tooltip">{{ element.EmployerName }}</span>
              </mat-cell>
            </ng-container>

            <!-- EmployerObject Column -->
            <ng-container matColumnDef="EmployerObject">
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header="EmployerObjectName"
                class="hidden-sort"
                [style.minWidth.px]="getColumnWidth('EmployerObject')"
                [style.maxWidth.px]="getColumnWidth('EmployerObject')"
              >
                {{ 'EmployerObject' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" [style.minWidth.px]="getColumnWidth('EmployerObject')" [style.maxWidth.px]="getColumnWidth('EmployerObject')">
                <span [matTooltip]="element.EmployerObjectName" matTooltipClass="annexes-registry-tooltip">{{ element.EmployerObjectName }}</span>
              </mat-cell>
            </ng-container>

            <!-- AgreementType Column -->
            <ng-container matColumnDef="AgreementType">
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header="AgreementType"
                class="hidden-sort"
                [style.minWidth.px]="getColumnWidth('AgreementType')"
                [style.maxWidth.px]="getColumnWidth('AgreementType')"
              >
                {{ 'WL-AgreementType' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" [style.minWidth.px]="getColumnWidth('AgreementType')" [style.maxWidth.px]="getColumnWidth('AgreementType')">
                <span [matTooltip]="element.AgreementType" matTooltipClass="annexes-registry-tooltip">{{ element.AgreementType }}</span>
              </mat-cell>
            </ng-container>

            <!-- AgreementNumber Column -->
            <ng-container matColumnDef="AgreementNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header="AgreementNumber" class="hidden-sort">
                {{ 'WL-AgreementNumber' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                @if (hasDetailsAccess()) {
                <a
                  [routerLink]="['/workers', element.WorkerId, 'employmentType', element.EmploymentTypeId, 'agreements', element.WorkerAgreementId, 'details']"
                  [matTooltip]="'AnnexRegistry.GoToAgreement' | translate"
                  matTooltipClass="annexes-registry-tooltip"
                >{{ element.AgreementNumber }}</a>
                } @else {
                <span>{{ element.AgreementNumber }}</span>
                }
              </mat-cell>
            </ng-container>

            <!-- AnnexNumber Column -->
            <ng-container matColumnDef="AnnexNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header="AnnexNumber" class="hidden-sort">
                {{ 'AnnexRegistry.AnnexNumber' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.AnnexNumber }}</mat-cell>
            </ng-container>

            <!-- StartDate Column -->
            <ng-container matColumnDef="StartDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header="StartDate" class="hidden-sort">
                {{ 'AnnexRegistry.StartDateFrom' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.StartDate | date: 'yyyy-MM-dd' }}</mat-cell>
            </ng-container>

            <!-- EndDate Column -->
            <ng-container matColumnDef="EndDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header="EndDate" class="hidden-sort">
                {{ 'AnnexRegistry.EndDateTo' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.EndDate | date: 'yyyy-MM-dd' }}</mat-cell>
            </ng-container>

            <!-- AnnexStatus Column -->
            <ng-container matColumnDef="AnnexStatus">
              <mat-header-cell *matHeaderCellDef mat-sort-header="AnnexStatusId" class="hidden-sort">
                {{ 'AnnexRegistry.AnnexStatus' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div
                  class="label"
                  [class.label--green]="element.AnnexStatusId === AnnexStatusEnum.Active || element.AnnexStatusId === AnnexStatusEnum.Accepted"
                  [class.label--yellow]="element.AnnexStatusId === AnnexStatusEnum.PendingApproval"
                  [class.label--blue]="element.AnnexStatusId === AnnexStatusEnum.GeneratingSignedAnnex"
                  [class.label--orange]="element.AnnexStatusId === AnnexStatusEnum.Inactive || element.AnnexStatusId === AnnexStatusEnum.TerminatedAnnex"
                >
                  <span class="label__dot"></span>
                  <span class="label__name">{{ element.AnnexStatusName }}</span>
                </div>
                @if (isAdmin && element.IsConsistent === false) {
                <mat-icon
                  class="warn-icon"
                  [matTooltip]="'AnnexRegistry.InconsistentAnnex' | translate"
                  matTooltipClass="annexes-registry-tooltip"
                >warning</mat-icon>
                }
                <app-annex-imported-badge [visible]="element.IsImported" />
              </mat-cell>
            </ng-container>

            <!-- ExternalSystemSyncStatus Column -->
            <ng-container matColumnDef="ExternalSystemSyncStatus">
              <mat-header-cell *matHeaderCellDef class="hidden-sort">
                {{ 'AnnexRegistry.ExternalSyncStatus' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                @if (element.AnnexSyncStatusId && !element.IsImported) {
                <div class="label" [ngClass]="getExternalSyncStatusClass(element.AnnexSyncStatusId)">
                  <span class="label__dot"></span>
                  <span class="label__name">{{ element.AnnexSyncStatusName }}</span>
                </div>
                } @else {
                <span>—</span>
                }
              </mat-cell>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="Actions" stickyEnd>
              <mat-header-cell *matHeaderCellDef>{{ 'WAD-Actions' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                @if (hasAnyActions(element)) {
                <button mat-button class="button-text" [matMenuTriggerFor]="menuRow">
                  <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                </button>

                <mat-menu #menuRow="matMenu" panelClass="actions-menu">
                  @if (hasDetailsAccess()) {
                  <button
                    mat-button
                    [disabled]="element.IsImported"
                    (click)="openAnnexDetailsPanel(element)"
                  >
                    <mat-icon class="material-icons-outlined">visibility</mat-icon>
                    <span class="button-text">{{ 'AnnexRegistry.ShowAnnexDetails' | translate }}</span>
                  </button>
                  }
                  @if (hasDetailsAccess()) {
                  <button mat-button (click)="openAnnexDetailsPanelOnChangedTab(element)">
                    <mat-icon class="material-icons-outlined">description</mat-icon>
                    <span class="button-text">{{ 'AnnexRegistry.ShowAnnexChangedData' | translate }}</span>
                  </button>
                  }
                  @if (isPendingApproval(element)) {
                  <button mat-button (click)="navigateToAnnexSignature(element)">
                    <mat-icon class="material-icons-outlined">draw</mat-icon>
                    <span class="button-text">{{ 'AnnexRegistry.SignAnnex' | translate }}</span>
                  </button>
                  }
                  @if (hasDetailsAccess()) {
                  <button mat-button (click)="navigateToAgreementDetails(element)">
                    <mat-icon class="material-icons-outlined">article</mat-icon>
                    <span class="button-text">{{ 'WL-WorkerAgreementDetails' | translate }}</span>
                  </button>
                  }
                  @if (isAdmin && element.AnnexSyncStatusId === AnnexSyncStatusEnum.Error) {
                  <button mat-button (click)="onReEnqueueImportTask(element)">
                    <mat-icon class="material-icons-outlined">replay</mat-icon>
                    <span class="button-text">{{ 'Annex.ReEnqueueImportTask' | translate }}</span>
                  </button>
                  <button mat-button [disabled]="!isAdmin || element.AnnexSyncStatusId !== AnnexSyncStatusEnum.Error" (click)="onSkipImportTask(element)">
                    <mat-icon class="material-icons-outlined">skip_next</mat-icon>
                    <span class="button-text">{{ 'Annex.SkipImportTask' | translate }}</span>
                  </button>
                  <button mat-button [disabled]="!isAdmin || element.AnnexSyncStatusId !== AnnexSyncStatusEnum.Error" (click)="onMarkAllImportTasksAsManuallyCorrected(element)">
                    <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                    <span class="button-text">{{ 'Annex.MarkAllImportTasksAsManuallyCorrected' | translate }}</span>
                  </button>
                  }
                </mat-menu>
                }
              </mat-cell>
            </ng-container>

            <!-- Progress Column -->
            <ng-container matColumnDef="progress">
              <mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
                <mat-progress-bar
                  [mode]="dataSource.isLoading ? 'indeterminate' : 'determinate'"
                  class="table-progress"
                  color="accent"
                ></mat-progress-bar>
              </mat-header-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: sticky" [style.top.px]="offset$ | async"></mat-header-row>
            <mat-header-row *matHeaderRowDef="['progress']; sticky: sticky" class="progress" [style.top.px]="((offset$ | async) ?? 0) + 56"></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: displayedColumns"
              (click)="openAnnexDetailsPanel(row)"
              [class.row--active]="row.AnnexId === activeAnnexId"
            ></mat-row>
          </mat-table>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
    <app-item-counter class="item-counter" [position]="scrollItemPosition" [length]="dataSource?.absoluteDataLength"></app-item-counter>
  </div>
</div></app-split>
